import React, { useState, useEffect } from 'react';
import {
  Box,
  Paper,
  Typography,
  Button,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Snackbar,
  Alert,
  CircularProgress,
  Chip,
  Card,
  CardContent,
  Grid,
  Divider,
  Fab,
  Tooltip,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  InputAdornment,
  Collapse
} from '@mui/material';
import {
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Save as SaveIcon,
  Cancel as CancelIcon,
  Refresh as RefreshIcon,
  Lock as LockIcon,
  Search as SearchIcon,
  FilterList as FilterListIcon,
  Clear as ClearIcon,
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon
} from '@mui/icons-material';
import Avatar from "@mui/material/Avatar";
import { useUser } from "./Context/UserContext";
import { useNavigate } from "react-router-dom";
import Pagination from '@mui/material/Pagination';

const SquMaintenance = () => {
  const navigate = useNavigate();
  const { user } = useUser();
  const isAdmin = user?.Admin === 1;
  const username = user?.ID;
  const [records, setRecords] = useState([]);
  const [shops, setShops] = useState([]);
  const [authorizedUserIDs, setAuthorizedUserIDs] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [editingRecord, setEditingRecord] = useState(null);
  const [showFilters, setShowFilters] = useState(false);
  const [formData, setFormData] = useState({
    SquName: '',
    creatorUser: username || '',
    shopName: ''
  });
  const [loading, setLoading] = useState(false);
  const [shopsLoading, setShopsLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success'
  });
  const [filters, setFilters] = useState({
    SquID: '',
    SquName: '',
    ShopName: '',
    creatorUser: ''
  });

  let status = "1";
  let path =
    status === "0" ? "http://localhost:3003" : "https://outlettee.com:3003";

  // Filtrelenmiş kayıtları getir
  const getFilteredRecords = () => {
    return records.filter(record => {
      const squIdMatch = record.SquID?.toString().toLowerCase().includes(filters.SquID.toLowerCase());
      const squNameMatch = record.SquName?.toLowerCase().includes(filters.SquName.toLowerCase());
      const shopNameMatch = (record.ShopName || record.shopName || '')?.toLowerCase().includes(filters.ShopName.toLowerCase());
      const creatorUserMatch = record.creatorUser?.toString().toLowerCase().includes(filters.creatorUser.toLowerCase());
      
      return squIdMatch && squNameMatch && shopNameMatch && creatorUserMatch;
    });
  };

  const filteredRecords = getFilteredRecords();

  // Filtre değerlerini güncelle
  const handleFilterChange = (field, value) => {
    setFilters(prev => ({
      ...prev,
      [field]: value
    }));
  };

  // Filtreleri temizle
  const clearFilters = () => {
    setFilters({
      SquID: '',
      SquName: '',
      ShopName: '',
      creatorUser: ''
    });
  };

  const getActiveFilterCount = () => {
    return Object.values(filters).filter(value => value.trim() !== '').length;
  };

  const hasPermission = (record, action = 'edit') => {
   
    if (action === 'delete') {
      console.log("Delete action - Admin only:", isAdmin);
      return isAdmin;
    }
    
    if (isAdmin) {
      console.log("Admin permissions - Full access");
      return true;
    }
    
    const usernameNum = parseInt(username);
    const creatorUserNum = parseInt(record.creatorUser);
    
    console.log("Parsed numbers - username:", usernameNum, "creatorUser:", creatorUserNum);
    
    if (creatorUserNum === usernameNum) {
      console.log("Own record - Access granted");
      return true;
    }
    
    const hasAuthorization = authorizedUserIDs.includes(creatorUserNum);
    console.log("Authorization check:", hasAuthorization);
    console.log("Record creator in authorized list:", authorizedUserIDs.includes(creatorUserNum));
    
    return hasAuthorization;
  };

  const showSnackbar = (message, severity = 'success') => {
    setSnackbar({
      open: true,
      message,
      severity
    });
  };

  const fetchShops = async () => {
    try {
      setShopsLoading(true);
      const response = await fetch(`${path}/api/getShopsByCaptainOrSelf`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          UserID: username,
          IsAdmin: isAdmin ? 1 : 0
        }),
      });

      if (response.ok) {
        const data = await response.json();
        console.log("Shops response data:", data);
        
        setShops(data);
        
        // Backend'den dönen UserID'leri yetkili kullanıcılar olarak kaydet
        const userIDs = data.map(item => parseInt(item.UserID));
        setAuthorizedUserIDs(userIDs);
        
        console.log("Authorized UserIDs set:", userIDs);
      } else {
        showSnackbar('Shoplar getirilemedi', 'error');
      }
    } catch (error) {
      console.error('Shops fetch error:', error);
      showSnackbar('Shop verilerinde bağlantı hatası', 'error');
    } finally {
      setShopsLoading(false);
    }
  };

const [page, setPage] = useState(1);
const [limit, setLimit] = useState(50);
const [total, setTotal] = useState(0);

const fetchRecords = async () => {
  setLoading(true);
  const response = await fetch(`${path}/api/squRecords?page=${page}&limit=${limit}`);
  if (response.ok) {
    const data = await response.json();
    setRecords(data.records);
    setTotal(data.total);
  }
  setLoading(false);
};

// page veya limit değiştiğinde fetchRecords çalıştır
useEffect(() => {
  fetchRecords();
}, [page, limit]); // page veya limit değiştiğinde tetiklenir

  // Dialog aç
  const openAddDialog = () => {
    setEditingRecord(null);
    setFormData({ 
      SquName: '', 
      creatorUser: username || '',
      shopName: ''
    });
    setOpenDialog(true);
  };

  const openEditDialog = (record) => {
    // Yetki kontrolü
    if (!hasPermission(record, 'edit')) {
      showSnackbar('Bu kaydı düzenleme yetkiniz yok', 'error');
      return;
    }

    console.log("Edit record:", record);
    console.log("ShopName options:", record.shopName, record.ShopName);

    setEditingRecord(record);
    setFormData({
      SquName: record.SquName || '',
      creatorUser: record.creatorUser || '',
      shopName: record.shopName || record.ShopName || ''
    });
    setOpenDialog(true);
  };

  // Dialog kapat
  const closeDialog = () => {
    setOpenDialog(false);
    setEditingRecord(null);
    setFormData({ 
      SquName: '', 
      creatorUser: username || '',
      shopName: ''
    });
  };

  // Form gönder
  const handleSubmit = async () => {
    if (!formData.SquName.trim()) {
      showSnackbar('Lütfen SquName alanını doldurunuz', 'warning');
      return;
    }

    if (!formData.shopName.trim()) {
      showSnackbar('Lütfen bir shop seçiniz', 'warning');
      return;
    }

    // Yeni kayıt eklerken creatorUser'ı mevcut kullanıcı yap
    const submitData = {
      ...formData,
      creatorUser: editingRecord ? formData.creatorUser : username,
      userID: username,
      isAdmin: isAdmin
    };

    try {
      setLoading(true);
      let response;
      
      if (editingRecord) {
        // Güncelleme - yetki kontrolü
        if (!hasPermission(editingRecord, 'edit')) {
          showSnackbar('Bu kaydı güncelleme yetkiniz yok', 'error');
          return;
        }
        
        response = await fetch(`${path}/api/squRecords/${editingRecord.id}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(submitData),
        });
      } else {
        // Yeni kayıt ekleme
        console.log("formData", submitData);
        response = await fetch(`${path}/api/squRecords`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(submitData),
        });
      }

      if (response.ok) {
        showSnackbar(
          editingRecord ? 'Kayıt başarıyla güncellendi' : 'Kayıt başarıyla eklendi',
          'success'
        );
        closeDialog();
        fetchRecords();
      } else {
        const error = await response.json();
        showSnackbar(error.error || 'İşlem başarısız', 'error');
      }
    } catch (error) {
      console.error('Submit error:', error);
      showSnackbar('Bağlantı hatası', 'error');
    } finally {
      setLoading(false);
    }
  };

  // Kayıt sil
  const deleteRecord = async (id) => {
    try {
      setLoading(true);
      const response = await fetch(`${path}/api/squRecords/${id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          userID: username,
          isAdmin: isAdmin
        }),
      });

      if (response.ok) {
        showSnackbar('Kayıt başarıyla silindi', 'success');
        fetchRecords();
      } else {
        const error = await response.json();
        showSnackbar(error.error || 'Kayıt silinemedi', 'error');
      }
    } catch (error) {
      console.error('Delete error:', error);
      showSnackbar('Bağlantı hatası', 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteClick = (record) => {
    // Sadece adminler silebilir
    if (!isAdmin) {
      showSnackbar('Kayıt silme yetkisi sadece adminlerde bulunmaktadır', 'error');
      return;
    }

    if (window.confirm(`"${record.SquName}" kaydını silmek istediğinizden emin misiniz?`)) {
      deleteRecord(record.id);
    }
  };

  // Yetkili kullanıcı sayısını hesapla
  const getAuthorizedRecordsCount = () => {
    return filteredRecords.filter(record => 
      hasPermission(record, 'edit')
    ).length;
  };

  useEffect(() => {
    fetchRecords();
    fetchShops();
  }, []);

  useEffect(() => {
    // Username değiştiğinde formData'yı güncelle
    setFormData(prev => ({
      ...prev,
      creatorUser: username || ''
    }));
  }, [username]);

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f5f5f5', p: 3 }}>
      <Box sx={{ maxWidth: 1200, mx: 'auto' }}>
        {/* Header Card */}
        <Card sx={{ mb: 3, background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
          <CardContent sx={{ color: 'white', py: 4 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Box>
                <Typography variant="h3" component="h1" gutterBottom sx={{ fontWeight: 'bold' }}>
                  SQU Bakım Yönetim Sistemi
                </Typography>
              </Box>
              <Box sx={{ textAlign: 'right' }}>
                <IconButton
                  onClick={() => navigate("/")}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    padding: "5px 15px",
                    borderRadius: "25px",
                    backgroundColor: "#fff",
                    "&:hover": {
                      backgroundColor: "#ccc",
                    },
                  }}
                >
                  <Avatar
                    src="/Logos/HORSE HEAD.svg"
                    alt="Ana Menü"
                    sx={{ width: 50, height: 50 }}
                  />
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: "bold",
                      color: "#000",
                    }}
                  >
                    Ana Menü
                  </Typography>
                </IconButton>
              </Box>
            </Box>
          </CardContent>
        </Card>

        {/* Stats Cards */}
        <Grid container spacing={3} sx={{ mb: 3 }}>
          <Grid item xs={12} sm={6} md={3}>
            <Card>
              <CardContent sx={{ textAlign: 'center' }}>
                <Typography color="textSecondary" gutterBottom>
                  Sayfadaki Kayıt
                </Typography>
                <Typography variant="h4" component="div" color="primary">
                  {records.length}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Card>
              <CardContent sx={{ textAlign: 'center' }}>
                <Typography color="textSecondary" gutterBottom>
                  Filtrelenmiş Kayıt
                </Typography>
                <Typography variant="h4" component="div" color="secondary">
                  {filteredRecords.length}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Card>
              <CardContent sx={{ textAlign: 'center' }}>
                <Typography color="textSecondary" gutterBottom>
                  Düzenleyebileceğim
                </Typography>
                <Typography variant="h4" component="div" color="success.main">
                  {getAuthorizedRecordsCount()}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Card>
              <CardContent sx={{ textAlign: 'center' }}>
                <Typography color="textSecondary" gutterBottom>
                  Yetki Durumu
                </Typography>
                <Typography variant="h6" component="div" color={isAdmin ? 'error.main' : 'info.main'}>
                  {isAdmin ? 'Admin' : `Yetkili (${authorizedUserIDs.length} kişi)`}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        {/* Main Content Card */}
        <Card>
          <CardContent>
            {/* Action Bar */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
              <Typography variant="h5" component="h2" sx={{ fontWeight: 'bold' }}>
              
              </Typography>
              <Box sx={{ display: 'flex', gap: 1 }}>
                <Button
                  variant="outlined"
                  startIcon={showFilters ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                  onClick={() => setShowFilters(!showFilters)}
                  color={getActiveFilterCount() > 0 ? 'secondary' : 'primary'}
                >
                  Filtreler {getActiveFilterCount() > 0 && `(${getActiveFilterCount()})`}
                </Button>
                <Button
                  variant="outlined"
                  startIcon={<RefreshIcon />}
                  onClick={fetchRecords}
                  disabled={loading}
                >
                  Yenile
                </Button>
                <Button
                  variant="contained"
                  startIcon={<AddIcon />}
                  onClick={openAddDialog}
                  sx={{ 
                    background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
                    boxShadow: '0 3px 5px 2px rgba(33, 203, 243, .3)',
                  }}
                >
                  Yeni Kayıt
                </Button>
              </Box>
            </Box>

            {/* Filters Section */}
            <Collapse in={showFilters}>
              <Card variant="outlined" sx={{ mb: 3, bgcolor: '#f8f9fa' }}>
                <CardContent>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <FilterListIcon sx={{ mr: 1, color: 'primary.main' }} />
                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                      Filtreleme Seçenekleri
                    </Typography>
                    {getActiveFilterCount() > 0 && (
                      <Button
                        size="small"
                        startIcon={<ClearIcon />}
                        onClick={clearFilters}
                        sx={{ ml: 'auto' }}
                        color="secondary"
                      >
                        Tümünü Temizle
                      </Button>
                    )}
                  </Box>
                  
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={3}>
                      <TextField
                        fullWidth
                        size="small"
                        label="Squ No Ara"
                        variant="outlined"
                        value={filters.SquID}
                        onChange={(e) => handleFilterChange('SquID', e.target.value)}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchIcon color="action" />
                            </InputAdornment>
                          ),
                          endAdornment: filters.SquID && (
                            <InputAdornment position="end">
                              <IconButton
                                size="small"
                                onClick={() => handleFilterChange('SquID', '')}
                              >
                                <ClearIcon fontSize="small" />
                              </IconButton>
                            </InputAdornment>
                          )
                        }}
                        placeholder="Örn: 001, 125..."
                      />
                    </Grid>
                    
                    <Grid item xs={12} sm={6} md={3}>
                      <TextField
                        fullWidth
                        size="small"
                        label="Listing Name Ara"
                        variant="outlined"
                        value={filters.SquName}
                        onChange={(e) => handleFilterChange('SquName', e.target.value)}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchIcon color="action" />
                            </InputAdornment>
                          ),
                          endAdornment: filters.SquName && (
                            <InputAdornment position="end">
                              <IconButton
                                size="small"
                                onClick={() => handleFilterChange('SquName', '')}
                              >
                                <ClearIcon fontSize="small" />
                              </IconButton>
                            </InputAdornment>
                          )
                        }}
                        placeholder="Listing adı..."
                      />
                    </Grid>
                    
                    <Grid item xs={12} sm={6} md={3}>
                      <FormControl fullWidth size="small">
                        <InputLabel>Shop Filtrele</InputLabel>
                        <Select
                          value={filters.ShopName}
                          onChange={(e) => handleFilterChange('ShopName', e.target.value)}
                          label="Shop Filtrele"
                          endAdornment={filters.ShopName && (
                            <InputAdornment position="end" sx={{ mr: 3 }}>
                              <IconButton
                                size="small"
                                onClick={() => handleFilterChange('ShopName', '')}
                              >
                                <ClearIcon fontSize="small" />
                              </IconButton>
                            </InputAdornment>
                          )}
                        >
                          <MenuItem value="">
                            <em>Tümü</em>
                          </MenuItem>
                          {/* Unique shop names from records */}
                          {[...new Set(records.map(record => record.ShopName || record.shopName).filter(Boolean))]
                            .sort()
                            .map((shopName) => (
                              <MenuItem key={shopName} value={shopName}>
                                {shopName}
                              </MenuItem>
                            ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    
              
                  </Grid>
                  
                  {getActiveFilterCount() > 0 && (
                    <Box sx={{ mt: 2, display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                      <Typography variant="body2" color="textSecondary" sx={{ mr: 1 }}>
                        Aktif Filtreler:
                      </Typography>
                      {filters.SquID && (
                        <Chip 
                          label={`SquID: ${filters.SquID}`} 
                          size="small" 
                          onDelete={() => handleFilterChange('SquID', '')}
                          color="primary"
                          variant="outlined"
                        />
                      )}
                      {filters.SquName && (
                        <Chip 
                          label={`SquName: ${filters.SquName}`} 
                          size="small" 
                          onDelete={() => handleFilterChange('SquName', '')}
                          color="primary"
                          variant="outlined"
                        />
                      )}
                      {filters.ShopName && (
                        <Chip 
                          label={`Shop: ${filters.ShopName}`} 
                          size="small" 
                          onDelete={() => handleFilterChange('ShopName', '')}
                          color="primary"
                          variant="outlined"
                        />
                      )}
                      {filters.creatorUser && (
                        <Chip 
                          label={`Kullanıcı: ${filters.creatorUser}`} 
                          size="small" 
                          onDelete={() => handleFilterChange('creatorUser', '')}
                          color="primary"
                          variant="outlined"
                        />
                      )}
                    </Box>
                  )}
                </CardContent>
              </Card>
            </Collapse>

            <Divider sx={{ mb: 3 }} />

            {/* Table */}
            {loading && records.length === 0 ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
                <CircularProgress size={60} />
              </Box>
            ) : records.length === 0 ? (
              <Box sx={{ textAlign: 'center', py: 8 }}>
                <Typography variant="h6" color="textSecondary">
                  Henüz kayıt bulunmamaktadır
                </Typography>
                <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
                  Yeni bir kayıt eklemek için yukarıdaki butonu kullanın
                </Typography>
              </Box>
            ) : filteredRecords.length === 0 ? (
              <Box sx={{ textAlign: 'center', py: 8 }}>
                <SearchIcon sx={{ fontSize: 60, color: 'text.secondary', mb: 2 }} />
                <Typography variant="h6" color="textSecondary">
                  Filtreleme sonucu kayıt bulunamadı
                </Typography>
                <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
                  Farklı filtre kriterleri deneyin veya filtreleri temizleyin
                </Typography>
                <Button
                  variant="outlined"
                  onClick={clearFilters}
                  sx={{ mt: 2 }}
                  startIcon={<ClearIcon />}
                >
                  Filtreleri Temizle
                </Button>
              </Box>
            ) : (
              <TableContainer component={Paper} variant="outlined">
                <Table>
                  <TableHead>
                    <TableRow sx={{ bgcolor: '#f8f9fa' }}>
                      <TableCell sx={{ fontWeight: 'bold' }}>Squ No</TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }}>Listing Name</TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }}>Shop</TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }}>Güncelleme Tarihi</TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }} align="center">İşlemler</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {filteredRecords.map((record, index) => (
                      <TableRow 
                        key={record.id} 
                        sx={{ 
                          '&:hover': { bgcolor: '#f5f5f5' },
                          '&:nth-of-type(even)': { bgcolor: '#fafafa' },
                          // Düzenleyebileceği kayıtları vurgula
                          ...(hasPermission(record, 'edit') && {
                            bgcolor: '#ffffffff',
                            '&:hover': { bgcolor: '#d4edda' }
                          })
                        }}
                      >
                      
                        <TableCell>
                          <Chip 
                            label={record.SquID} 
                            color="primary" 
                            variant="outlined" 
                            size="small"
                          />
                        </TableCell>
                        <TableCell sx={{ fontWeight: 'medium' }}>{record.SquName}</TableCell>
                        <TableCell>
                          <Chip 
                            label={record.shopName || record.ShopName || 'Belirtilmemiş'} 
                            color={record.shopName || record.ShopName ? "secondary" : "default"}
                            variant="outlined" 
                            size="small"
                          />
                        </TableCell>
                      
                        <TableCell>
                          {new Date(record.updateDate).toLocaleString('tr-TR')}
                        </TableCell>
                        <TableCell align="center">
                          <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
                            {hasPermission(record, 'edit') ? (
                              <Tooltip title="Düzenle">
                                <IconButton
                                  onClick={() => openEditDialog(record)}
                                  color="primary"
                                  size="small"
                                >
                                  <EditIcon />
                                </IconButton>
                              </Tooltip>
                            ) : (
                              <Tooltip title="Düzenleme yetkiniz yok">
                                <IconButton
                                  disabled
                                  size="small"
                                >
                                  <LockIcon />
                                </IconButton>
                              </Tooltip>
                            )}
                            
                            {/* Silme butonu sadece adminler için gösterilir */}
                            {isAdmin ? (
                              <Tooltip title="Sil">
                                <IconButton
                                  onClick={() => handleDeleteClick(record)}
                                  color="error"
                                  size="small"
                                >
                                  <DeleteIcon />
                                </IconButton>
                              </Tooltip>
                            ) : (
                              <Tooltip title="Silme yetkiniz yok">
                                <IconButton
                                  disabled
                                  size="small"
                                >
                                  <LockIcon />
                                </IconButton>
                              </Tooltip>
                            )}
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                  <Pagination
                    count={Math.ceil(total / limit)}
                    page={page}
                    onChange={(e, val) => setPage(val)}
                    color="primary"
                    size="large"
                    showFirstButton
                    showLastButton
                  />
                </Box>
              </TableContainer>
            )}
          </CardContent>
        </Card>

        {/* Floating Action Button */}
        <Fab
          color="primary"
          aria-label="add"
          onClick={openAddDialog}
          sx={{
            position: 'fixed',
            bottom: 24,
            right: 24,
            background: 'linear-gradient(45deg, #FF6B6B 30%, #FF8E53 90%)',
            '&:hover': {
              background: 'linear-gradient(45deg, #FF5252 30%, #FF7043 90%)',
            }
          }}
        >
          <AddIcon />
        </Fab>

        {/* Dialog */}
        <Dialog 
          open={openDialog} 
          onClose={closeDialog}
          maxWidth="sm"
          fullWidth
          PaperProps={{
            sx: { borderRadius: 3 }
          }}
        >
          <DialogTitle sx={{ 
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white',
            fontWeight: 'bold'
          }}>
            {editingRecord ? 'Kayıt Düzenle' : 'Yeni Kayıt Ekle'}
          </DialogTitle>
          <DialogContent sx={{ pt: 3 }}>
            <TextField
              autoFocus
              margin="dense"
              label="SquName"
              fullWidth
              variant="outlined"
              value={formData.SquName}
              onChange={(e) => setFormData({...formData, SquName: e.target.value})}
              sx={{ mb: 2 }}
            />
            
            <FormControl fullWidth variant="outlined" sx={{ mb: 2 }}>
              <InputLabel id="shop-select-label">Shop Seçin</InputLabel>
              <Select
                labelId="shop-select-label"
                value={formData.shopName}
                onChange={(e) => setFormData({...formData, shopName: e.target.value})}
                label="Shop Seçin"
                disabled={shopsLoading}
              >
                {shopsLoading ? (
                  <MenuItem disabled>
                    <CircularProgress size={20} sx={{ mr: 1 }} />
                    Yükleniyor...
                  </MenuItem>
                ) : shops.length === 0 ? (
                  <MenuItem disabled>Shop bulunamadı</MenuItem>
                ) : (
                  shops.map((shop) => (
                    <MenuItem key={shop.ShopID || shop.ShopName} value={shop.ShopName}>
                      {shop.ShopName}
                    </MenuItem>
                  ))
                )}
              </Select>
            </FormControl>
            
            <TextField
              margin="dense"
              label="Oluşturan Kullanıcı"
              fullWidth
              variant="outlined"
              value={formData.creatorUser}
              disabled={!editingRecord || !isAdmin}
              onChange={(e) => setFormData({...formData, creatorUser: e.target.value})}
              helperText={!isAdmin ? "Otomatik olarak sizin kullanıcı ID'niz atanacak" : ""}
            />
          </DialogContent>
          <DialogActions sx={{ p: 3 }}>
            <Button 
              onClick={closeDialog}
              startIcon={<CancelIcon />}
              variant="outlined"
            >
              İptal
            </Button>
            <Button 
              onClick={handleSubmit}
              startIcon={loading ? <CircularProgress size={16} /> : <SaveIcon />}
              variant="contained"
              disabled={loading}
              sx={{
                background: 'linear-gradient(45deg, #4CAF50 30%, #45a049 90%)',
                '&:hover': {
                  background: 'linear-gradient(45deg, #45a049 30%, #3d8b40 90%)',
                }
              }}
            >
              {loading ? 'Kaydediliyor...' : 'Kaydet'}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Snackbar */}
        <Snackbar
          open={snackbar.open}
          autoHideDuration={4000}
          onClose={() => setSnackbar({...snackbar, open: false})}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        >
          <Alert 
            onClose={() => setSnackbar({...snackbar, open: false})} 
            severity={snackbar.severity}
            variant="filled"
          >
            {snackbar.message}
          </Alert>
        </Snackbar>
      </Box>
    </Box>
  );
};

export default SquMaintenance;